export default __webpack_public_path__ + "static/media/btn-enter-bg.b178d196.png";